import React, { useEffect, useState } from 'react'
import { BiExport, BiImport } from "react-icons/bi"
import { toast } from 'react-toastify'
import Select from 'react-select'
import Loader from '../../Components/Loader'
import { destinationService, locationServices } from '../../Services'

const REACT_APP_API_BASEURL = process.env.REACT_APP_API_BASEURL

export const InlandDestinationChargeList = () => {

    const [loader, setLoader] = useState(true)
    const [listData, setListData] = useState([]);
    const [countryList, setCountryList] = useState([])
    const [countryValue, setCountryValue] = useState('')
    const [errcountry, SetErrcountry] = useState();
    const [serviceType, SetServiceType] = useState({ value: 'AIR', label: 'AIR' });

    useEffect(() => {
        getCountryList()
    }, [])

    const getCountryList = () => {
        let param = { page: 1, limit: 300 };
        locationServices.getCountry(param).then(res => {
            if (res.status) {
                let arry = []
                // arry.push({ value: '', label: 'All country' })
                res.data.map(list => {
                    arry.push({ value: list._id, label: list.country_name })
                })
                const initialValue = res.data.filter((res) => res.country_iso2 === 'IN')[0]
                
                setCountryValue({ value: initialValue._id, label: initialValue.country_name })
                // setCountryValue(arry)
                setCountryList(arry)
                getItemList(arry[0], serviceType)
            }
        })
    }

    const getItemList = (countryId, serviceType) => {
        setLoader(true)
        setCountryValue(countryId)
        SetServiceType(serviceType)
        let param = { }   
        if (countryId) {
            param['country_id'] = countryId.value
        }
        if (serviceType) {
            param['service_type'] = serviceType.value
        }

        destinationService.getLocaltariffs(param).then(res => {
            if (res.status) {
                setLoader(false)
                setListData(res.data)
            } else {
                setLoader(false)
            }
        })
    }


    // const onClickExport = () => {
    //     destinationService.exportLocalTariffData().then((res) => {
    //         console.log("res", res)
    //         if (res.status) {
    //             window.location.href = REACT_APP_API_BASEURL + res.data
    //             toast.success("file download successfully")
    //         } else {
    //             toast.error(res.message)
    //         }
    //     })
    // }

    const onClickExport = () => {
        setLoader(true);
        var errorcount = 0;
        console.log(countryValue,'countryValue')
        if (countryValue.value === undefined ) {
            SetErrcountry("*country is required.");
            errorcount++;
        }
        console.log(serviceType,'serviceType')
        if (!serviceType?.value) {
            errorcount++;
        }

        if(listData.length <= 0){
            toast.error('No data found !');
            errorcount++;
        }
        let postData = {
            local_tariff_country : countryValue.value,
            service_type : serviceType.value
        }
        if (errorcount === 0) {
            destinationService.exportLocalTariffData(postData).then((res) => {
                if (res.status) {
                    window.location.href = REACT_APP_API_BASEURL + "/" + res.data
                    toast.success("file download successfully")
                    setLoader(false);
                    // getItemList();
                } else {
                    toast.error(res.message)
                }
            })
        }else{
            setLoader(false);
        }
    }

    const onClickImport = (e) => {
        setLoader(true);
        var Errcount = 0;

        if (countryValue.value === undefined) {
            SetErrcountry("*country is required.");
            Errcount++;
        }

        const formData = new FormData()
        formData.append('csv_file', e.target.files[0]);
        formData.append('local_tariff_country', countryValue.value);
        formData.append('service_type', serviceType.value);
        // let postData = {
        //     ...formData,
        //     local_tariff_country: countryValue.value
        // }

        // formData.append('local_tariff_country', countryValue.value)
        if(Errcount === 0){
            destinationService.importLocalTariffData(formData).then((res) => {
                if (res.status) {
                    setLoader(false);
                    getItemList(countryValue, serviceType);
                    toast.success("file upload successfully")
                } else {
                    toast.error(res.message)
                    setLoader(false);
                }
            })
        }
    }

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="d-flex justify-content-between mb-3">
                            <div className="d-flex justify-content-between mb-3">
                                <div>
                                    <Select
                                        styles={{
                                            valueContainer: (provided) => ({
                                                ...provided,
                                                height: 'calc(2.15rem + 2px)',
                                                overflowY: 'visible'
                                            }),
                                            control: (provider) => ({
                                                ...provider,
                                                width: '200px',
                                                boxShadow: '0 0 0 0px #f46a6a'
                                            }),
                                            placeholder: (provider) => ({
                                                ...provider,
                                                color: '#a0b0ca'
                                            })
                                        }}
                                        placeholder="Select Country"
                                        value={countryValue}
                                        onChange={(e) => getItemList(e, serviceType) }
                                        options={countryList}
                                    />
                                    {
                                        !countryValue.value &&
                                        <div className="text-danger">{errcountry}</div>
                                    }
                                </div>
                                <div className='ms-3'>
                                    <Select
                                        styles={{
                                            valueContainer: (provided) => ({
                                                ...provided,
                                                height: 'calc(2.15rem + 2px)',
                                                overflowY: 'visible'
                                            }),
                                            control: (provider) => ({
                                                ...provider,
                                                width: '200px',
                                                boxShadow: '0 0 0 0px #f46a6a'
                                            }),
                                            placeholder: (provider) => ({
                                                ...provider,
                                                color: '#a0b0ca'
                                            })
                                        }}
                                        placeholder="Select Mode"
                                        value={serviceType}
                                        onChange={(e) => getItemList(countryValue,e)}
                                        options={[
                                            { value: 'AIR', label: 'AIR' },
                                            { value: 'SEA', label: 'SEA' },
                                            // { value: 'LAND', label: 'LAND' },
                                            // { value: 'COURIER', label: 'COURIER' },
                                        ]}
                                    />
                                </div>
                            </div>
                            <div className="d-flex justify-content-end mb-3">
                                <div>
                                    <input
                                        type="file"
                                        id="upload"
                                        accept=".csv"
                                        hidden
                                        onChange={(e) => onClickImport(e)}
                                    />
                                    <label
                                        htmlFor="upload"
                                        className="btn btn-danger waves-effect waves-light mx-1 my-0"
                                    >
                                        <BiExport />
                                        Upload File
                                    </label>
                                </div>
                                <div>
                                <button className="btn btn-success waves-effect waves-light mx-1 my-0"
                                    onClick={() => onClickExport()}
                                >
                                    <BiImport />
                                    Download File
                                </button>
                                </div>
                            </div>
                        </div>
                        <div className="table-responsive">
                            {listData.length > 0 &&
                                <table className="table table-centered table-nowrap mb-0">
                                    <thead className="table-light">
                                        <tr>
                                            <th className="p-1 small">Dist (KMS)</th>
                                            {listData.length > 0 && listData[0].local_tariff_price.map((list, key) => (
                                                <th key={list.min_distance} className="p-1 small">{list.min_distance + "-" + list.max_distance}</th>
                                            ))}
                                        </tr>
                                        <tr>
                                            <th className="p-1 small">Vol (CBM)</th>
                                            {/* {listData.length > 0 && listData[0].local_tariff_price.map((list, key) => (
                                            <th key={list.min_distance} className="p-1 small">KMS</th>
                                        ))} */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {listData.length > 0 && listData.map((list, key) => (
                                            <tr key={key}>
                                                {list.local_tariff_volume && <th className="p-1 small">{list.local_tariff_volume}</th>}
                                                {list.local_tariff_price.map((item) => (
                                                    <React.Fragment key={item.max_distance}>
                                                        {item.price != null ?
                                                            <td
                                                                className="p-1 small"
                                                            >
                                                                {Number(item.price).toFixed(2)}
                                                            </td>
                                                            : <></>
                                                        }
                                                    </React.Fragment>
                                                )
                                                )}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>}
                            {listData.length <= 0 && !loader &&
                                <div className="text-center w-100 bg-warning my-5">
                                    <h6 className="py-2"> No data available</h6>
                                </div>
                            }
                        </div>
                    </div>
                    <Loader isShow={loader} />
                </div>
            </div>
        </div>
    )
}
